import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { StatisticState } from './types';

import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: StatisticState = {
  emailStatisticDetail: [],
  emailStatisticDetailInfo: undefined,
  emailStatisticGroup: [],
  emailGroupings: {
    emailGroup: [
      'hour',
      'day',
      'week',
      'month',
    ],
    emailGroupOptionally: [
      'broker_account_login',
      'originator',
      'message_type',
      'template_id',
      'bulk_id',
    ],
    emailEventsGroupOptionally: [
      'broker_account_login',
      'originator',
      'message_type',
      'template_id',
      'bulk_id',
      'partner',
      'recipient',
      'service_provider',
    ],
  },
  eventTypeList: [
    'opening',
    'unsubscribing',
    'subscribing',
    'following_link',
  ],
  emailDetailEvents: [],
};

export const emailStatistic: Module<StatisticState, RootState> = {
  state,
  getters,
  actions,
  mutations,
};